import React from "react";
import "../../css/components/controls/HrnbLoader.css";

export default function HrnbLoader({
                                       size = 44,
                                       color = "#2399E3",
                                       text = "hrnb",
                                       className = ""
                                   }) {
    return (
        <div className={`hrnb-loader-wrap ${className}`}>
            <div
                className="hrnb-loader-spinner"
                style={{
                    width: size,
                    height: size,
                    borderTopColor: color,
                    borderRightColor: color,
                }}
                aria-label="Загрузка..."
            />
            {text && (
                <div className="hrnb-loader-text-anim">
                    {text}
                </div>
            )}
        </div>
    );
}
